import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "./AwarenessCampaign.css";
import Footer from "../Home/Footer";
import ValueAddedProductsImage from "../assets/img/Valueaddedproducts.jpg";
import OrganicHoneyImage from "../assets/img/OrganicHoney.jpg";
import DairyProductionImage from "../assets/img/DairyProduction.jpg";
import DryFruitExportImage from "../assets/img/DryFruitexport.jpg";
import HeaderVideo from "../assets/video/Awarenesscampaign.mp4";

const successStories = [
  {
    id: 1,
    image: OrganicHoneyImage,
    title: "Organic Honey Business",
    description:
      "How a small farmer turned beekeeping into a thriving enterprise.",
  },
  {
    id: 2,
    image: DairyProductionImage,
    title: "Dairy Processing",
    description: "From raw milk to artisan cheese—creating a new market.",
  },
  {
    id: 3,
    image: DryFruitExportImage,
    title: "Dried Fruit Exports",
    description:
      "Processing fresh fruits into long-lasting, profitable snacks.",
  },
];

const AwarenessCampaign = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="awareness-page">
      {/* Hero Section with Video Background */}
      <section className="hero-section">
        <video autoPlay loop muted className="bg-video">
          <source src={HeaderVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="overlay"></div>
        <div className="container text-center position-relative">
          <h1
            className="display-4 fw-bold"
            data-aos="fade-down"
            style={{ color: "#d4561a" }}
          >
            Awareness Campaign for Value-Added Products
          </h1>
          <p className="lead text-light" data-aos="fade-up">
            Enhancing the value of agricultural products through innovation and
            sustainability.
          </p>
          <a
            href="#learn-more"
            className="btn btn-warning mt-3"
            data-aos="zoom-in"
          >
            Learn More
          </a>
        </div>
      </section>

      {/* About Value-Added Products */}
      <section id="learn-more" className="about-section py-5 mb-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6" data-aos="fade-right">
              <img
                src={ValueAddedProductsImage}
                className="img-fluid rounded shadow-lg"
              />
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <h2 className="fw-bold" style={{ color: "#d4561a" }}>
                What Are Value-Added Products?
              </h2>
              <p>
                As part of its revenue-generation activity, ISDA will facilitate
                a promotional and awareness campaign to raise awareness around
                soy food products and increase consumption of these products by
                the general public.
              </p>
              {/* <ul className="mt-2">
                <li>Increases farmers' profitability</li>
                <li>Improves food sustainability</li>
                <li>Encourages innovation in the industry</li>
              </ul> */}
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      {/* <section className="success-stories py-5 text-light text-center mt-5">
        <div className="container">
          <h2
            className="fw-bold"
            data-aos="fade-up"
            style={{ color: "#d4561a" }}
          >
            Success Stories
          </h2>
          <p data-aos="fade-up">
            Discover inspiring stories of farmers and entrepreneurs who
            transformed raw produce into profitable products.
          </p>
          <div className="row mt-4">
            {successStories.map((story, index) => (
              <div
                key={story.id}
                className="col-md-4"
                data-aos="zoom-in"
                data-aos-delay={index * 200}
              >
                <div className="story-card">
                  <img
                    src={story.image}
                    alt={story.title}
                    className="img-fluid rounded"
                  />
                  <h5 className="mt-3" style={{ color: "#d4561a" }}>
                    {story.title}
                  </h5>
                  <p>{story.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Call to Action */}
      {/* <section className="cta-section text-center py-5">
        <div className="container">
          <h2
            className="fw-bold"
            data-aos="fade-up"
            style={{ color: "#d4561a" }}
          >
            Join the Movement
          </h2>
          <p className="lead" data-aos="fade-up" style={{ color: "white" }}>
            Be a part of the value-added product revolution. Get expert guidance
            and grow your business.
          </p>
          <Link
            to="/contact-us"
            className="btn mt-3"
            data-aos="zoom-in"
            style={{ backgroundColor: "#d4561a", color: "black" }}
          >
            Get Involved
          </Link>
        </div>
      </section> */}
      <Footer />
    </div>
  );
};

export default AwarenessCampaign;
